<template>
  <v-app>
    <v-app-bar height="96" light color="white" elevate-on-scroll app>
      <v-app-bar-title>
          <v-img class="Pointer" @click="$router.push('/')" height="48" width="68" src="@/assets/logo_black.png"></v-img>
      </v-app-bar-title>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <v-col>
        <v-row class="hidden-sm-and-down" justify="end" no-gutters>
          <span>
            <v-icon class="mr-1">mdi-email-outline</v-icon>info@wildceylonadventure.com
          </span>
          <v-divider vertical class="ml-2 mr-2"></v-divider>
          <span>
            <v-icon class="mr-1">mdi-phone-outline</v-icon>+9471 580 8080
          </span>
        </v-row>
        <v-row class="hidden-sm-and-down mt-2" justify="end" no-gutters>
          <v-btn color="#146A57" class="font-weight-bold" text to="/">Home</v-btn>
          <v-btn color="#146A57" class="font-weight-bold" text to="/packages">Packages</v-btn>
          <v-btn color="#146A57" class="font-weight-bold" text to="/contactus">Contact Us</v-btn>
        </v-row>
      </v-col>





      <v-app-bar-nav-icon @click="NavDrawer = !NavDrawer" class="hidden-md-and-up"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer temporary disable-resize-watcher right app v-model="NavDrawer" class="hidden-md-and-up">
        <v-list>
          <v-list-item link to="/">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/packages">
            <v-list-item-title>Packages</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/contactus">
            <v-list-item-title>Contact Us</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view/>
    </v-main>


      <v-footer v-if="$route.path !== '/packages'" padless>
        <v-card
            flat
            tile
            width="100%"
            class="black lighten-1 text-center">
          <v-card-text class="pb-0">
            <v-row justify="center" no-gutters>
              <v-img class="Pointer" @click="$router.push('/')"
                     height="48" width="68" contain src="@/assets/logo_white.png"></v-img>
            </v-row>

            <v-row no-gutters justify="center" class="white--text mt-2">
              <span style="word-break: keep-all;white-space: nowrap" class="PatuaFontClean white--text text-h7">
              Kerris Wild, <span class="PatuaFont">Relish Wild</span>, Cherish Wild...
            </span>
            </v-row>

            <v-row no-gutters justify="center" class="mt-5">
              <v-btn target="_blank" href="https://www.facebook.com/wildceylonadventuressrilanka/" dark icon>
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn target="_blank" href="https://www.instagram.com/wild.ceylon.adventures" dark icon>
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="white--text pt-0 mt-6">
            © {{ new Date().getFullYear() }} <strong>Wild Ceylon Adventures (Pvt) Ltd.</strong>
          </v-card-text>
        </v-card>
      </v-footer>
  </v-app>
</template>

<script>
export default {
  name:'App',
  data:()=>({
    NavDrawer: false,
  })
}
</script>

<style>

html {
  scroll-behavior: smooth;
}

.Pointer{
  cursor: pointer;
}
.PlayFairFont{
  font-family: 'Playfair Display',serif !important;
}

.v-btn {
  text-transform:none !important;
}


.ThemeFont{
  color: #07614D !important;
}

.ThemeFont2{
  color: #07614D !important;
}

.ThemeFont2{
  color: #FDC27B !important;
}
</style>

<style lang="scss">
#app {
  font-family: Poppins, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background-image: url("/assets/app_bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

body {
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px;
}

.title-font {
  font-family: 'Poppins', sans-serif;
  font-size: 40px;
  color: #07614D;
  font-weight: 600;
}

.primary-font {
    font-family: 'Poppins', sans-serif;
}

.HeadSection {
  .hero-section {
    height: 100%;
    display: flex;
    align-items: flex-end;

    .hero-body {
      display: block;
      margin: auto;
      width: fit-content;

      .v-card {
        margin-bottom: 20px;

        .logo {
          .v-image {
            width: 100px;
            height: auto;
            display: block;
            margin: auto;
          }
        }

        h1 {
          font-family: 'Patua One',serif !important;
          font-size: 44px;
          font-weight: 500;
          color: #ffff;
        }
      } 
    }
  }
}

.who-we-are {
  background:linear-gradient(0deg, rgb(7 97 77 / 35%), rgb(7 97 77 / 35%)), url(/assets/safari.jpg);
  padding-top: 120px;
  padding-bottom: 120px;
  margin-top: 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.opacity {
  opacity: 0.5;
}

.color-overlay {
  background-color: #07614D !important;
}
</style>
